import script from "./Invoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./Invoices.vue?vue&type=script&setup=true&lang=ts"

import "./Invoices.vue?vue&type=style&index=0&id=31e4f6fe&lang=scss"

const __exports__ = script;

export default __exports__